import React, { useEffect } from "react";
import './index.scss';
import ReactPlayer from 'react-player';

import iconDirection from '../../../img/projects/Elipse 39.svg';

import ImgOne from '../../../img/details/detailseven/RW-1.jpg';
import ImgTwo from '../../../img/details/detailseven/RW-2.jpg';
import ImgThree from '../../../img/details/detailseven/RW-3.jpg';
import ImgFour from '../../../img/details/detailseven/RW-4.jpg';
import ImgFive from '../../../img/details/detailseven/RW-5.gif';
import ImgSix from '../../../img/details/detailseven/RW-6.jpg';
import Brandin from '../../../img/details/detailseven/RW-7.gif';
import ImgEight from '../../../img/details/detailseven/RW-8.jpg';
import ImgNine from '../../../img/details/detailseven/RW-9.jpg';
import ImgTen from '../../../img/details/detailseven/RW-10.jpg';
import ImgEleven from '../../../img/details/detailseven/RW-12.jpg';
import ImgTwelve from '../../../img/details/detailseven/RW-13.jpg';
import ImgThirteen from '../../../img/details/detailseven/RW-14.jpg';
import ImgFourteen from '../../../img/details/detailseven/RW-15.jpg';
import ImgFiveteen from '../../../img/details/detailseven/RW-13.jpg';
import ImgSixteen from '../../../img/details/detailseven/RW-16.jpg';
import ImgSeventeen from '../../../img/details/detailseven/RW-17.jpg';
import ImgEighteen from '../../../img/details/detailseven/RW-18.jpg';
import ImgNineteen from '../../../img/details/detailseven/RW-20.gif';

import HeaderContainer from '../../header/index';
import PageSeven from '../../../views/pagesevenblack';
import ProjectNav from '../../../common/ProjectNav';

const DetailProjectSeven = () => {
    useEffect(() => {
        const timer = setTimeout(() => {
            const element = document.getElementById("ProjectSix");
            if (element) element.scrollIntoView({ block: "start", behavior: "smooth" });
        }, 400);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="containerDetailSix" id="ProjectSix">
            <HeaderContainer name="normalWhite" />

            <div className="ContentProjects">
                <div className="ContentProjectsTitle">
                    <div className="ContentProjectsLeft">
                        <a href="/projects" style={{ textDecoration: "none", color: "#000" }}>
                            <img loading="lazy" src={iconDirection} alt="Our Work" />
                            Our Work
                        </a>
                    </div>
                    <div className="ContentProjectsRight">
                        We take pride in your success
                    </div>
                </div>

                <div className="ContentProjectsViewImgageOneDetailSix">
                    <div className="ContentProjectsViewImgageLeft">
                        <img loading="lazy" src={ImgOne} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewText">
                    <text className="title">Revelwear</text>
                    <text>
                        <label>THE BRAND</label>
                        Revelwear is a groundbreaking brand in the fashion and wellness industry, providing diabetics with freedom and discretion along with the luxury of being comfortable and fashionable. You no longer have to choose health needs over style.
                    </text>
                    <text>
                        <label>THE MISSION</label>
                        To bring the brand into the 21st century with a cohesive, memorable and powerful brand that reflects the innovation, quality and style of Revelwear, while also transmitting the message of freedom and wellbeing. We wanted your customer to know that your products aren't just products they need but they are styles they want.
                    </text>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgTwo} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageOneDetailSix">
                    <div className="ContentProjectsViewImgageLeft">
                        <img loading="lazy" src={ImgThree} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgFour} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={Brandin} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageOneDetailSix">
                    <div className="ContentProjectsViewImgageLeft">
                        <img loading="lazy" src={ImgFive} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgSix} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgEight} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgNine} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgTen} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgEleven} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgThirteen} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgFourteen} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgFiveteen} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgSixteen} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgSeventeen} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgEighteen} alt="" width="100%" />
                    </div>
                </div>

                <div className="ContentProjectsViewImgageTwoDetailSix">
                    <div className="ContentProjectsViewImgageRight">
                        <img loading="lazy" src={ImgNineteen} alt="" width="100%" />
                    </div>
                </div>
            </div>

            <ProjectNav current="/detailseven" />
            <PageSeven />
        </div>
    );
};

export default DetailProjectSeven;
